import classnames from 'classnames';
import { CaseMatchType, ConflictedReservation } from '@/api/apis/resources';
import { getReservationStatus } from './utils';

type ConflictReservationProps = {
  reservation?: ConflictedReservation;
  caseTypeMatch: CaseMatchType;
  caseName?: string;
  isColumn?: boolean;
};

export const ConflictReservationInfo = ({
  reservation,
  caseTypeMatch,
  caseName,
  isColumn = false,
}: ConflictReservationProps) => {
  const alreadyAssigned =
    caseTypeMatch === CaseMatchType.AlreadyAssigned || caseTypeMatch === CaseMatchType.AlreadyReserved;
  if (reservation || alreadyAssigned) {
    return (
      <div className={classnames('flex', { 'flex-col justify-between': isColumn, 'gap-2': !isColumn })}>
        <span className={classnames('text-danger-20', { 'text-xs-m': isColumn })}>
          {getReservationStatus(caseTypeMatch)}
        </span>
        <span className={classnames({ 'text-xs-m text-base-5': isColumn })}>{reservation?.caseName || caseName}</span>
      </div>
    );
  }

  return false;
};
